"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterItemsByRoles = filterItemsByRoles;
exports.getUniqueKey = void 0;
exports.hasPermissions = hasPermissions;
exports.onLanguageChanged = onLanguageChanged;
exports.resolveCustomItems = resolveCustomItems;
exports.shouldShowSearch = shouldShowSearch;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _qs = _interopRequireDefault(require("qs"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Configuration-specific utilities have been moved to config/utils.tsx
// This file now contains only destination/runtime utilities
function shouldShowSearch() {
  if (typeof window === 'undefined') return false;
  return document.querySelector('.searchbar-in-hero,.hero-search') === null && location.pathname !== '/search';
}

function injectAtPosition(array, item, position) {
  var result = (0, _toConsumableArray2.default)(array);

  if (position >= result.length) {
    result.push(item);
  } else {
    result.splice(position, 0, item);
  }

  return result;
}
/**
 * Resolves the custom items and injects them at the correct position
 * @param items - The items to resolve
 * @returns The resolved items
 */


function resolveCustomItems(items) {
  if (typeof window === 'undefined') return items;
  var customItems = window.customMegaMenuItems;
  if (!customItems) return items;
  var allItems = items.concat(customItems);
  var itemsWithPosition = allItems.filter(function (item) {
    return item.position !== undefined;
  });
  var itemsWithoutPosition = allItems.filter(function (item) {
    return item.position === undefined;
  });
  itemsWithPosition.sort(function (a, b) {
    var _a$position, _b$position;

    return ((_a$position = a.position) !== null && _a$position !== void 0 ? _a$position : 0) - ((_b$position = b.position) !== null && _b$position !== void 0 ? _b$position : 0);
  });
  return itemsWithoutPosition.reduce(function (result, item) {
    var position = result.findIndex(function (posItem) {
      var _posItem$position;

      return ((_posItem$position = posItem.position) !== null && _posItem$position !== void 0 ? _posItem$position : 0) > itemsWithoutPosition.indexOf(item);
    });
    return injectAtPosition(result, item, position === -1 ? result.length : position);
  }, itemsWithPosition);
}

function onLanguageChanged(languageCode) {
  var _window$location = window.location,
      protocol = _window$location.protocol,
      host = _window$location.host,
      pathname = _window$location.pathname;

  var currentUrlQuery = _qs.default.parse(window.location.search, {
    ignoreQueryPrefix: true
  });

  var newUrlQuery = _objectSpread(_objectSpread({}, currentUrlQuery), {}, {
    lang: languageCode.toLowerCase()
  });

  var redirectUrl = "".concat(protocol, "//").concat(host).concat(pathname, "?").concat(_qs.default.stringify(newUrlQuery));
  window.location.replace(redirectUrl);
}

function hasPermissions(item, permissions) {
  if (item === 'productUpdates' || item === 'ideation') {
    return permissions[item];
  }

  return true;
}

var getUniqueKey = function getUniqueKey(item) {
  var _item$url;

  // Note: item.key is not unique
  return item.key + String((_item$url = item.url) !== null && _item$url !== void 0 ? _item$url : item.name);
};

exports.getUniqueKey = getUniqueKey;

function filterItemsByRoles(items, roles) {
  return items.filter(function (item) {
    if (item.key !== 'custom' && item.key !== 'custom-link') {
      return true;
    }

    var hasMatchingRoles = !item.roles || item.roles.length === 0 || item.roles.some(function (role) {
      return roles.includes(role);
    });

    if (item.children) {
      item.children = item.children.filter(function (child) {
        return !child.roles || child.roles.length === 0 || child.roles.some(function (role) {
          return roles.includes(role);
        });
      });
    }

    return hasMatchingRoles || item.children && item.children.length > 0;
  });
}